import { render, staticRenderFns } from "./CountryNotAllowed.vue?vue&type=template&id=2efc884e&scoped=true&"
import script from "./CountryNotAllowed.vue?vue&type=script&lang=js&"
export * from "./CountryNotAllowed.vue?vue&type=script&lang=js&"
import style0 from "./CountryNotAllowed.vue?vue&type=style&index=0&id=2efc884e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efc884e",
  null
  
)

export default component.exports